export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  //{
 //   label: 'Articles',
 //  pathname: '/articles',
 // },
  {
    label: 'About',
    pathname: '/',
    hash: '#about',
  },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'Twitter',
    url: 'https://twitter.com/jaisury53707453',
    icon: 'twitter',
  },
  {
    label: 'linkedin',
    url: 'https://www.linkedin.com/in/t-jai-surya-prasad-ba0a91126/',
    icon: 'linkedin',
  },
  {
    label: 'Github',
    url: 'https://github.com/jspjai',
    icon: 'github',
  },
];
